import {useTranslation} from '@aboutyou/i18n';
import {
  Button,
  COLORS,
  GenericIconName,
  HEADER_HEIGHT,
  Icon,
} from '@aboutyou/ui-components';
import React from 'react';
import sc, {css} from 'styled-components';
import {useInlineSizeSelectionQuickViewAB} from '../AddToBasketQuickView/hooks/useInlineSizeSelectionQuickViewAB';

export const SimilarItemsQuickView: React.FC<{
  similarProductsRef: React.RefObject<HTMLElement | null>;
}> = ({similarProductsRef}) => {
  const {t} = useTranslation();
  const inlineSizeSelectionQuickViewAB = useInlineSizeSelectionQuickViewAB();
  const handleClick = () => {
    if (similarProductsRef.current) {
      const top =
        similarProductsRef.current.getBoundingClientRect().top +
        window.scrollY -
        HEADER_HEIGHT;

      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    }
  };

  return (
    <SimilarItemsWrapper
      $enablePositionAbsolute={inlineSizeSelectionQuickViewAB}
    >
      <Button
        variant={inlineSizeSelectionQuickViewAB ? 'glassy' : 'floating'}
        size={inlineSizeSelectionQuickViewAB ? 'full-width' : 'fit-width'}
        data-testid="scrollToSimilarItemsButton"
        onClick={handleClick}
        aria-label={undefined}
        rightIcon={
          <Icon
            asset={GenericIconName.ArrowDown}
            size="XXS"
            color={COLORS.Black}
            data-testid="scrollToSimilarItemsIcon"
          />
        }
      >
        <span data-testid="scrollToSimilarItemsLabel">
          {t('Discover alternatives')}
        </span>
      </Button>
    </SimilarItemsWrapper>
  );
};

const SimilarItemsWrapper = sc.div<{$enablePositionAbsolute?: boolean}>`
  ${props =>
    props.$enablePositionAbsolute
      ? css`
          position: absolute;
          bottom: 4px;
        `
      : css`
          position: fixed;
          bottom: 1rem;
        `}

  left: 0;
  right: 0;
  width: fit-content;
  margin: 0 auto;
  z-index: 1;
  padding: 1rem;

  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(10px);
    }
    60% {
      transform: translateY(5px);
    }
  }

  // The animation should only run two times. https://aboutyou.atlassian.net/browse/ASFE-8132
  animation: bounce 2s 2;
`;
